import {Injectable} from '@angular/core';
import {Mapper} from '../../../core/abstracts/mapper.abstract';
import {GeocodingResponse} from '../model/geocoding-response.model';
import {Geocoding} from '../model/geocoding.model';

@Injectable({providedIn: 'root'})
export class GeocodingResponseMapper extends Mapper<GeocodingResponse, Geocoding> {

  public override map(source: GeocodingResponse): Geocoding {
    return new Geocoding(
      source.lat,
      source.lon
    )
  }
}
